import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logos/sidebarlogo.png'


const _hoisted_1 = { class: "container 2xl:max-w-[1320px] mx-auto px-[12px]" }
const _hoisted_2 = { class: "flex items-center relative flex-wrap lg:flex-nowrap justify-between" }
const _hoisted_3 = { class: "hidden lg:flex items-center justify-center grow" }
const _hoisted_4 = { class: "flex flex-row gap-[30px] xl:gap-[50px] mx-auto" }
const _hoisted_5 = { class: "hidden lg:flex items-center gap-[15px]" }
const _hoisted_6 = { class: "my-[14px] md:my-[16px] first:mt-0 last:mb-0" }
const _hoisted_7 = { class: "my-[14px] md:my-[16px] first:mt-0 last:mb-0" }
const _hoisted_8 = { class: "my-[14px] md:my-[16px] first:mt-0 last:mb-0" }
const _hoisted_9 = { class: "my-[14px] md:my-[16px] first:mt-0 last:mb-0" }
const _hoisted_10 = { class: "my-[14px] md:my-[16px] first:mt-0 last:mb-0" }
const _hoisted_11 = { class: "flex items-center gap-[15px] mt-[14px] md:mt-[16px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'fixed top-0 right-0 left-0 transition-all h-auto z-[10000] py-[20px]',
      { 'is-sticky': _ctx.isSticky },
    ]),
    id: "navbar"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RouterLink, {
          to: "/",
          class: "inline-block max-w-[130px] mr-[15px]"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "logo",
              class: "inline-block"
            }, null, -1)
          ])),
          _: 1,
          __: [1]
        }),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["inline-block relative leading-none lg:hidden", ['navbar-toggler', { active: _ctx.stateStoreInstance.active }]]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.activeBtn && _ctx.stateStoreInstance.activeBtn(...args)))
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "h-[3px] w-[30px] my-[5px] block bg-black dark:bg-white" }, null, -1),
          _createElementVNode("span", { class: "h-[3px] w-[30px] my-[5px] block bg-black dark:bg-white" }, null, -1),
          _createElementVNode("span", { class: "h-[3px] w-[30px] my-[5px] block bg-black dark:bg-white" }, null, -1)
        ]), 2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: "/",
                class: "font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600 text-[15px] xl:text-md"
              }, {
                default: _withCtx(() => _cache[3] || (_cache[3] = [
                  _createTextVNode(" Home ")
                ])),
                _: 1,
                __: [3]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: "/features",
                class: "font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600 text-[15px] xl:text-md"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode(" Features ")
                ])),
                _: 1,
                __: [4]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: "/team",
                class: "font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600 text-[15px] xl:text-md"
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Our Team ")
                ])),
                _: 1,
                __: [5]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: "/faq",
                class: "font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600 text-[15px] xl:text-md"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode(" FAQ's ")
                ])),
                _: 1,
                __: [6]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_RouterLink, {
                to: "/contact",
                class: "font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600 text-[15px] xl:text-md"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" Contact ")
                ])),
                _: 1,
                __: [7]
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_RouterLink, {
            to: "/authentication/sign-in",
            class: "inline-block text-purple-600 lg:text-[15px] xl:text-[16px] py-[11px] px-[17px] rounded-md transition-all font-medium border border-purple-600 hover:text-white hover:bg-purple-500 hover:border-purple-500"
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createElementVNode("span", { class: "inline-block relative pl-[25px] md:pl-[29px]" }, [
                _createElementVNode("i", { class: "material-symbols-outlined absolute left-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-[24px]" }, " login "),
                _createTextVNode(" Login ")
              ], -1)
            ])),
            _: 1,
            __: [8]
          })
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([
            'bg-white dark:bg-black mt-[20px] p-[20px] md:p-[30px] w-full hidden lg:!hidden',
            { show: _ctx.stateStoreInstance.active },
          ])
        }, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", _hoisted_6, [
              _createVNode(_component_RouterLink, {
                to: "/",
                class: "font-medium text-primary-600 dark:text-primary-600 transition-all hover:text-primary-600"
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" Home ")
                ])),
                _: 1,
                __: [9]
              })
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createVNode(_component_RouterLink, {
                to: "/features",
                class: "font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode(" Features ")
                ])),
                _: 1,
                __: [10]
              })
            ]),
            _createElementVNode("li", _hoisted_8, [
              _createVNode(_component_RouterLink, {
                to: "/team",
                class: "font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode(" Our Team ")
                ])),
                _: 1,
                __: [11]
              })
            ]),
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_RouterLink, {
                to: "/faq",
                class: "font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode(" FAQ's ")
                ])),
                _: 1,
                __: [12]
              })
            ]),
            _createElementVNode("li", _hoisted_10, [
              _createVNode(_component_RouterLink, {
                to: "/contact",
                class: "font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600"
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode(" Contact ")
                ])),
                _: 1,
                __: [13]
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_RouterLink, {
              to: "/authentication/sign-in",
              class: "inline-block text-purple-600 lg:text-[15px] xl:text-[16px] py-[11px] px-[17px] rounded-md transition-all font-medium border border-purple-600 hover:text-white hover:bg-purple-500 hover:border-purple-500"
            }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createElementVNode("span", { class: "inline-block relative pl-[25px] md:pl-[29px]" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined absolute left-0 top-1/2 -translate-y-1/2 !text-[20px] md:!text-[24px]" }, " login "),
                  _createTextVNode(" Login ")
                ], -1)
              ])),
              _: 1,
              __: [14]
            })
          ])
        ], 2)
      ])
    ])
  ], 2))
}